import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { required } from '@cred/react-basic-form-fields/validators'
import Font from '@cred/react-font'
import {numberFromCurrency} from '@cred/shared/utils'
import Money from '@cred/react-basic-form-fields/hookForm/Money'
import CtaButton from '@cred/react-cta'
import ComponentTag from '@cred/react-component-tag'
import * as packageJson from './package.json'
import styles from './DTICalculator.module.scss'

const DtiCalculator = ({componentTag}) => {
  const [dti, setDti] = useState(0)
  const { handleSubmit, control, formState: { isValid } } = useForm()
  const onCalculate = (formValues) => {
    const debt = numberFromCurrency(formValues.debt)
    const income = numberFromCurrency(formValues.income)
    setDti(Math.floor(100 * debt/income))
  }

  return (
    <form method="POST" onSubmit={handleSubmit(onCalculate)} {...componentTag}>
      <div className={`${styles.panel} mb-24`}>
        <Font weight="bold" className="mb-24">Debt-to-income ratio</Font>
        <Font type="xLarge" weight="bold" className={`${styles.dti} mb-24`} data-testid="dti">{dti}%</Font>
        <Font type="bodySmall">A DTI less than 36% is ideal</Font>
      </div>
      <Money
        id="dtiDebt"
        name="debt"
        label="Recurring monthly debt"
        placeholder="Recurring monthly debt"
        className="mb-24"
        control={control}
        controllerProps={{rules: {validate: {req: required()}}}}
        exposeValue
      />
      <Money
        id="dtiIncome"
        name="income"
        label="Gross monthly income"
        placeholder="Gross monthly income"
        className="mb-24"
        control={control}
        controllerProps={{rules: {validate: {req: required()}}}}
        exposeValue
      />
      <CtaButton className={styles.cta} showDisabled={!isValid}>Calculate</CtaButton>
    </form>
  )
}

export default ComponentTag(packageJson)(DtiCalculator)
